import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useTranslation } from "react-i18next";
import Slider from "./slider/Slider"
import Newset from "./newset/Newset";
import Offers from "./offers/Offers";
import BestSelling from "./best/Best";
import RandomProducts from "./randomProducts/RandomProducts";
import { useHomeQuery } from "src/store/api/core/coreApiSlice";
import { ErrorScreen, LoadingPage } from "src/components";
import { authSelector } from "src/store/reducers/auth";
import { useScrollToTop } from "src/hooks";
import classes from "./styles.module.css";




const Home = () => {
    const { t } = useTranslation(["home"]);
    const auth = useSelector(authSelector);
    const didMountRef = useRef(false);
    const { data, isLoading, isFetching
        , isError, refetch } = useHomeQuery(undefined, {
            refetchOnReconnect: true,
            refetchOnMountOrArgChange: true,
        });

    useScrollToTop();
    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        refetch();
    }, [auth.access, refetch])

    const hasHomeData = Boolean(
        data?.slider_products?.length
        || data?.latest?.length
        || data?.offers?.length
        || data?.best?.length
    );

    if (isError && !hasHomeData) {
        return <ErrorScreen />
    }

    if (isLoading && !hasHomeData) {
        return <LoadingPage />
    }

    return (
        <main className={classes.page}>
            {isFetching && hasHomeData && (
                <div className={classes.refreshNotice}>
                    {t("refreshing")}
                </div>
            )}

            <Slider data={data?.slider_products || []} />
            <Newset data={data?.latest || []} />
            <Offers data={data?.offers || []} />
            <BestSelling data={data?.best || []} />
            <RandomProducts />
        </main>

    )
}

export default Home
